import { createStore } from '@stencil/store';

import { SelectOption } from '../interfaces/interface.banner';
import { YearRange } from '../services/services.eligibility';
import { BannerInstallationMode, BannerStep, GUID_EMPTY, consistentStoreAttributes } from '../utils/utils.interactive-banner';
import { baseVehicleState } from '../utils/utils.vehicle';

const initialState = {
  ...baseVehicleState,
  licensePlateNumber: '',
  licensePlateState: '',
  offerCode: 'w',
  dealerId: GUID_EMPTY,
  dealerGroupId: '',
  groupId: '',
  installationMode: BannerInstallationMode.PopUp,
  voiVin: '',
  tabList: 'vin-lp-ymm',
  tabHeaders: [],
  defaultSelectedTab: 'vin',
  currentSelectedTab: '',
  isFetching: false,
  activeStep: BannerStep.FormSelector,
  vehiclePossibilities: [] as SelectOption[],
  states: [] as SelectOption[],
  vehicleId: 0 as number,
  ymmSuggestions: [],
  furyUrl: null,
  optimizelyBannerIsActive: true,
  isServicesHealthy: true,
  isOpenModal: false,
  inputVin: '',
  inputYmm: '',
  zIndex: 2000 as number,
  vin: '',
  mileage: 0,
  yearId: 0,
  make: '',
  model: '',
  trim: '',
  offerId: '',
  amount: 0,
  status: '',
  expirationDate: '',
  markupAmounts: {},
  totalOfferAmounts: {},
  yearRange: {} as YearRange,
  isActiveListing: false,
  activeDealerListingUrl: '',
  measurementId: '',
  svocId: '',
  sdContainer: '',
  oemDealerCode: '',
  sessionId: '',
  isRequireVinPlate: false,
  dealershipAcceptsRv: false,
  cobrandingGroupAcceptsRv: false,
  cobrandingGroupMeasurementId: '',
};

const { state, on, onChange, reset } = createStore(initialState);

const resetVehicleData = () => {
  const saved = Object.fromEntries(consistentStoreAttributes.map((name) => [name, state[name]]));
  reset();
  Object.entries(saved).forEach(([name, value]) => {
    state[name] = value;
  });
};

export { initialState, on, onChange, state, reset, resetVehicleData };
export default state;
